var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOctopusNew = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#180048",
  fillRule: "evenodd",
  d: "M63 14.8a7.8 7.8 0 0 0-7.4 7.7c0 2.5 1.7 7.9 8.4 7.9.8 0 1.7-.1 2.5-.3v-3l-2.4.2a4.8 4.8 0 0 1-3.5-8.2 4.8 4.8 0 0 1 3.5-1.3h5.4v7.4s-.3 6.4 7.7 5v-3c-4.5 1-4.2-1.8-4.2-1.8v-7.6h4.2v-3H73v-3.6h-3.4v3.6zm49.6 1.5v7.6-.2.2c0 4.2 3 6.5 7.2 6.5 3.6 0 5.7-1.4 6.8-3.6 0 0 2.9 4 10.5 3.5 0 0 5.6 0 6-4.7 0 0 .6-3.7-4.7-4.5l-4.5-.6s-1.8-.3-1.7-1.7c0 0 0-2 4.1-1.7 3.4.2 4.8 1.5 4.8 1.5.5-.1 3.2-2.7-2.3-3.8 0 0-2.4-.6-6 0 0 0-3.9.5-4 4.2 0 0-.6 4.4 6 4.8l2 .2c1.6.2 2.5.5 2.7 1.8 0 0 .5 2.5-5.7 1.7 0 0-6.2-.5-6.6-7v-5.2s-3.1-1.2-3.4 1v7.1c0 2.6-1.7 3.8-4 3.8-2 0-3.8-1.2-3.8-3.8v-8.1s-3.1-1.2-3.4 1m-58 6c0 4.5-3.2 8-8.3 8a8 8 0 0 1-8.1-7.9c0-4.6 3.6-7.9 8.2-7.9s8.2 3.4 8.2 7.8m-8.2 5c2.7 0 4.7-2.1 4.7-4.9 0-2.7-1.8-4.9-4.7-4.9s-4.7 2.2-4.7 5c0 2.7 2 4.9 4.7 4.9Zm48-5c0 4.5-3.2 8-8.2 8a8 8 0 0 1-8.2-7.9c0-4.6 3.7-7.9 8.2-7.9 4.6 0 8.3 3.4 8.3 7.8Zm-8.2 5c2.8 0 4.7-2.1 4.7-4.9 0-2.7-1.7-4.9-4.7-4.9-2.8 0-4.6 2.2-4.6 5 0 2.7 1.9 4.9 4.6 4.9Zm9.3 8.6s3 1.2 3.4-1V28a6.1 6.1 0 0 0 4.6 2.3c4.8.2 8.1-3.3 8.1-8 0-4.4-3.4-7.9-8-7.8-5.4.2-8 3.7-8.1 8zM108 22.5c0 2.7-2 4.9-4.6 4.9-2.8 0-4.7-2.2-4.7-5 0-2.7 1.8-4.9 4.7-4.9 2.8 0 4.6 2.2 4.6 5",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF48D8",
  d: "M24.2 26.5c.5-2.2 3.2-4.5 3.5-8.1.5-4.8-2-13.2-13.7-13.2S.5 13.9.5 17.5C.5 22.4 4 25 4 26.7c.1 1.8-1.9 2-1.8 3.1.1.9 2.7 1.1 4.4.2a3 3 0 0 1-1.1 1.3c-1 .5-1.7.7-1.7 1.3 0 .5 2.8 2 5.6.6l1.8-1.3v.2c.2.8.7 3 2.7 3s2.4-1.9 2.7-3l.1-.3c.5.4 1.1 1 2 1.4 2.8 1.3 5.5 0 5.5-.6s-.7-.8-1.6-1.3c-.5-.3-1-.9-1.2-1.4 1.7 1 4.5.8 4.5-.1.2-1.2-2-1.3-1.7-3.3"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8.8 23.7a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  d: "M9 23.3a2.2 2.2 0 1 0 0-4.5 2.2 2.2 0 0 0 0 4.5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M7.7 20.3a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m11.1 3.2a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#c)",
  d: "M18.8 23.2a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.7 20.2a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#100030",
  d: "m22 14.6.2.1a3 3 0 0 1 .4.2l.2.3a.2.2 0 0 1-.2.3h-.1a1.2 1.2 0 0 0-.3-.1 3 3 0 0 0-.4-.1.4.4 0 1 1 .2-.7m-15.9 1H6a3 3 0 0 0-.5.2.2.2 0 0 1-.3-.3l.2-.2a2.2 2.2 0 0 1 .4-.2L6 15a.4.4 0 1 1 .2.6Zm6.6 9.9.1.1.3.1.5.1a2 2 0 0 0 .9-.2l.1-.1.4-.2a.2.2 0 0 1 .3.2.8.8 0 0 1 0 .4v.1l-.2.2-.4.4a2 2 0 0 1-1 .3c-.4 0-.8 0-1.1-.3l-.4-.4a1 1 0 0 1-.2-.7.3.3 0 0 1 .6-.1v.1Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 11.2,
  x2: 6.7,
  y1: 21,
  y2: 21,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#100030"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#180070"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 16.6,
  x2: 20.9,
  y1: 21,
  y2: 21,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#100030"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#180070"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.6 0H143v40H.6z"
})))));
export { SvgOctopusNew as ReactComponent };
export default new URL("/home/runner/_work/motorway-seller-webapp/motorway-seller-webapp/src/client/assets_seller/partners/octopusNew.svg", import.meta.url).toString();